import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Divider
} from '@mui/material';
import { EventOutlined, ScheduleOutlined } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

type CampaignType = 'event_driven' | 'scheduled' | '';

interface CampaignTypeSelectionProps {
  value: CampaignType;
  onChange: (type: CampaignType) => void;
  disabled?: boolean;
}

const CampaignTypeSelection: React.FC<CampaignTypeSelectionProps> = ({ value, onChange, disabled = false }) => {
  const { t } = useTranslation();

  return (
    <Card>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {t('campaignExperimental.create.campaignTypeTitle')}
        </Typography>
        <Divider sx={{ mb: 3 }} />
        
        <FormControl component="fieldset" fullWidth disabled={disabled}>
          <RadioGroup
            value={value}
            onChange={(e) => onChange(e.target.value as 'event_driven' | 'scheduled' | '')}
          >
            <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
              <FormControlLabel
                value="scheduled"
                control={<Radio />}
                disabled={disabled}
                label={
                  <Box sx={{ ml: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
                    <ScheduleOutlined color="primary" sx={{ fontSize: 28 }} />
                    <Box>
                      <Typography variant="body1" fontWeight="medium">
                        {t('campaignExperimental.create.scheduled')}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {t('campaignExperimental.create.scheduledDesc')}
                      </Typography>
                    </Box>
                  </Box>
                }
                sx={{
                  border: value === 'scheduled' ? '2px solid' : '1px solid',
                  borderColor: value === 'scheduled' ? 'primary.main' : 'grey.300',
                  borderRadius: 2,
                  p: 3,
                  m: 0,
                  flex: 1,
                  minWidth: '300px',
                  '&:hover': {
                    borderColor: 'primary.main',
                    bgcolor: 'primary.50'
                  }
                }}
              />
              <FormControlLabel
                value="event_driven"
                control={<Radio />}
                disabled={disabled}
                label={
                  <Box sx={{ ml: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
                    <EventOutlined color="primary" sx={{ fontSize: 28 }} />
                    <Box>
                      <Typography variant="body1" fontWeight="medium">
                        {t('campaignExperimental.create.eventDriven')}
                      </Typography>
                      <Typography variant="body2" color="textSecondary">
                        {t('campaignExperimental.create.eventDrivenDesc')}
                      </Typography>
                    </Box>
                  </Box>
                }
                sx={{
                  border: value === 'event_driven' ? '2px solid' : '1px solid',
                  borderColor: value === 'event_driven' ? 'primary.main' : 'grey.300',
                  borderRadius: 2,
                  p: 3,
                  m: 0,
                  flex: 1,
                  minWidth: '300px',
                  '&:hover': {
                    borderColor: 'primary.main',
                    bgcolor: 'primary.50'
                  }
                }}
              />
            </Box>
         </RadioGroup>
       </FormControl>
      </CardContent>
    </Card>
  );
};

export default CampaignTypeSelection;
